module.exports = __webpack_public_path__ + "img/fire3.6343ee8d.svg";